import { render } from "./StatisticsSection.vue?vue&type=template&id=714a2b14&scoped=true"
import script from "./StatisticsSection.vue?vue&type=script&lang=js"
export * from "./StatisticsSection.vue?vue&type=script&lang=js"

import "./StatisticsSection.vue?vue&type=style&index=0&id=714a2b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714a2b14"]])

export default __exports__